import { render } from "./ManageClients.vue?vue&type=template&id=60ba2288"
import script from "./ManageClients.vue?vue&type=script&lang=js"
export * from "./ManageClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ManageClients.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60ba2288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60ba2288', __exports__)) {
    api.reload('60ba2288', __exports__)
  }
  
  module.hot.accept("./ManageClients.vue?vue&type=template&id=60ba2288", () => {
    api.rerender('60ba2288', render)
  })

}


export default __exports__